import { Component, Input } from '@angular/core';
import { getChildrenFor } from './types';
export var JsonTreeComponent = (function () {
    function JsonTreeComponent() {
        this.children = [];
        this.expanded = true;
    }
    Object.defineProperty(JsonTreeComponent.prototype, "value", {
        set: function (value) {
            this.children = getChildrenFor(value);
        },
        enumerable: true,
        configurable: true
    });
    JsonTreeComponent.decorators = [
        { type: Component, args: [{
                    selector: 'ngrx-json-tree',
                    template: "\n    <ngrx-json-node *ngFor=\"let child of children\" [expanded]=\"expanded\" [value]=\"child.value\" [key]=\"child.key\"></ngrx-json-node>\n  "
                },] },
    ];
    /** @nocollapse */
    JsonTreeComponent.ctorParameters = [];
    JsonTreeComponent.propDecorators = {
        'expanded': [{ type: Input },],
        'value': [{ type: Input },],
    };
    return JsonTreeComponent;
}());
//# sourceMappingURL=json-tree.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngrx/store-log-monitor/src/json-tree/json-tree.js
// module id = y5CN
// module chunks = 4